import Stay from '../domain/Stay'
import Room from '../domain/Room'
import Hotel from '../domain/Hotel'
import Filter from '../domain/Filter'

export default class NewMapper {
  // TODO payUponArrival take from response first level, not calculate in real timer
  static fromJson ({ jsonHotel, jsonRooms, jsonStaysByRooms, minNightsPerStay, hotelCurrency, payUponArrival, searchApplicable, searchType, preselectedFilters }) {
    return new NewMapper({ jsonHotel, jsonRooms, hotelCurrency, jsonStaysByRooms, minNightsPerStay, payUponArrival, searchApplicable, searchType, preselectedFilters })
  }

  constructor ({ jsonHotel, jsonRooms, hotelCurrency, jsonStaysByRooms, minNightsPerStay, payUponArrival, searchApplicable, searchType, preselectedFilters }) {
    this.jsonHotel = jsonHotel
    this.jsonRooms = jsonRooms || []
    this.jsonStaysByRooms = jsonStaysByRooms || []
    this.minNightsPerStay = minNightsPerStay || 0
    this.hotelCurrency = hotelCurrency || 'USD'
    this.payUponArrival = payUponArrival
    this.searchApplicable = searchApplicable
    this.searchType = searchType || 'lowest'
    this.preselectedFilters = preselectedFilters || {}
  }

  toDomain () {
    const self = this

    const rooms = this.jsonRooms
      .map(json => {
        const tmsRoom = self.jsonStaysByRooms[json.tmsCode]
        const xbsRoom = self.jsonStaysByRooms[json.id]
        const stays = tmsRoom && tmsRoom.stays
          ? tmsRoom.stays
          : xbsRoom && xbsRoom.stays
            ? xbsRoom.stays
            : []

        return Room.fromJSON({
          ...json,
          // take only stays for every room
          stays: stays
            // remove stays that not should shows
            .filter(stay => !(this.searchType === 'eCert' && (!stay.matchesSearch || stay.category === 'loyalty')))
            .map(stay => Stay.fromJSON({
              ...stay,
              checkInTime: self.jsonHotel.checkInTime,
              checkOutTime: self.jsonHotel.checkOutTime,
              hotelMarkedAsMemberOnlyInCms: self.jsonHotel.memberOnlyRate,
              eCertIsApplied: self.searchType === 'eCert' && stay.matchesSearch, // TODO change to global searchApplicable
              comesFromTravelAgency: self.searchType === 'travelAgency'
            }))
        })
      })

    // map hotel
    const hotel = Hotel.fromJSON({
      ...this.jsonHotel,
      minNightsPerStay: this.minNightsPerStay,
      currency: this.hotelCurrency,
      rooms: rooms.filter(room => room.hasAvailableStays()),
      matchesSearch: this.searchApplicable // this.jsonR.a.t.e.s.filter(stay => stay.matchesSearch).length > 0
    })

    const availableStays = rooms
      .reduce((accumulation, room) => [...accumulation, ...room.stays], [])

    const filter = Filter.availableOptionsFrom(availableStays, this.preselectedFilters)

    return {
      hotel,
      filter
    }
  }
}
